<template>
  <span>
    <!-- Tab -->
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Purchase Order</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.purchase_order_id"
              :suggestions="purchase_orders"
              placeholder="Select Purchase Order"
            ></my-select>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Invoice Number</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.invoice_no"
              class="form-control"
              autocomplete="off"
              placeholder="Invoice Number"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Remarks</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.remarks"
              class="form-control"
              autocomplete="off"
              placeholder="Remarks"
            />
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "PurchaseOrderFormWidget",
  props: ["form"],
  data() {
    return {
      purchase_orders: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("invoices/masters");
      masters = masters.data;
      masters.purchase_orders.forEach((purchase_order) => {
        this.purchase_orders.push({
          id: purchase_order.id,
          name: purchase_order.po_no,
        });
      });
    },
  },
};
</script>
